<template>
  <el-card class="page-addressList">
    <div style="display: flex;" slot="header">
      <div style="flex: 1; display: flex" >
        <el-autocomplete
          v-model.trim="search"
          popper-class=""
          placeholder="搜索成员、科室"
          style="max-width: 350px; flex:1;"
          :trigger-on-focus="false"
          :fetch-suggestions="querySearch"
          @select="handleSelect"
        >
          <template slot-scope="{ item }">
            <div v-if="item.extra_type === 'dept'">科室： {{ item.dept_name }}</div>
            <div v-if="item.extra_type === 'doctor'">成员： {{ item.name }}</div>
          </template>
        </el-autocomplete>
      </div>
      <el-button round style="margin-left: 230px" @click="showAddressModal">新增成员</el-button>
      <el-button round style="margin-left: 20px" @click="showDeptModal">新增科室</el-button>
      <el-button type="primary" round style="margin-left: 20px" @click="showExcelModal">导入通讯录</el-button>
    </div>
    <el-row>
      <el-col :span="6" style="max-height: calc(100vh - 257px);min-height: 300px; overflow: auto;">
        <el-tree v-loading="deptLoading" ref="dept_tree" :data="deptList" :render-content="renderDeptContent" :default-expanded-keys="[1]" node-key="id" :highlight-current="true" @node-click="handleDeptNodeClick"></el-tree>
      </el-col>
      <el-col :span="18" style="max-height: calc(100vh - 257px);min-height: 300px;padding: 0 20px; overflow: auto;">
        <div style="margin-bottom: 16px; text-align: right">
          <Page
            :total="total"
            :current="page"
            :page-size="size"
            :page-size-opts="sizes"
            :show-total="true"
            :show-elevator="true"
            :show-sizer="true"
            @on-change="onCurrentChange"
            @on-page-size-change="onSizeChange"
          />
        </div>
        <Table :columns="columns" :data="dataSource" :loading="loading">
          <template slot-scope="{ row }" slot="action">
            <el-button type="text" @click="showAddressModal(row)">编辑</el-button>
          </template>
        </Table>
      </el-col>

    </el-row>
    <Modal
      v-model="show_excel"
      :styles="{ top: '25%' }"
      footer-hide
      title="导入对象"
      :z-index="999"
      @on-cancel="hideExcelModal"
    >
      <div>
        <div style="margin-bottom: 20px">
          <span><i class="el-icon-warning-outline"></i>仅允许导入"xlsx"或"xls"格式文件</span>
          <span style="color: #2d8cf0; cursor: pointer;" @click="downloadExcel">下载模板</span>
        </div>
        <Upload
          :multiple="false"
          type="drag"
          ref="upload"
          accept=".xlsx, .xls"
          :before-upload="handleUpload"
          :on-success="handleSuccess"
          :on-error="handleError"
          :headers="{
            Authorization: 'Bearer ' + $store.state.access_token,
            tenant: $store.state.tenant.tenant
          }"
          :action="USER_IMPORT"
          :show-file-list="false"
        >
          <div style="padding: 20px 0">
            <img src="../../images/icon_wuwj.png" alt="" style="width:140px" />
            <p>将文件拖拽到此处，或点击上传</p>
          </div>
        </Upload>
      </div>
    </Modal>
    <!-- <Modal v-model="addressShow" :mask-closable="false" width="550" @on-cancel="cancelAddress">
      <div slot="header" style="text-align: center">
        <span>新增通讯录成员</span>
      </div>
      <Form
        ref="form1"
        :model="curAddress"
        :rules="ruleAddress"
        :label-width="150"
        label-position="right"
        style="margin-left: -40px; margin-right: 40px"
      >
        <el-form-item label="成员名称" prop="name">
          <el-input
            v-model.trim="curAddress.name"
            :maxlength="30"
            placeholder="请输入成员名称"
          />
        </el-form-item>
        <el-form-item label="成员工号" prop="employee_id">
          <el-input
            v-model.trim="curAddress.employee_id"
            :maxlength="30"
            placeholder="请输入成员工号"
          />
        </el-form-item>
        <el-form-item v-show="!curAddress.id" label="密码" prop="password">
          <el-input
            v-model.trim="curAddress.password"
            :maxlength="30"
            type="password"
            placeholder="请输入成员密码"
          />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model.trim="curAddress.phone"
            :maxlength="30"
            placeholder="请输入成员手机"
          />
        </el-form-item>
        <el-form-item label="科室" prop="dept_id">
          <Select
            v-model="curAddress.dept_id"
            filterable
            placeholder="请选择科室"
          >
            <Option v-for="a in addressDept" :key="a.id" :value="a.id">{{
              a.dept_name
            }}</Option>
          </Select>
        </el-form-item>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelAddress">取消</el-button>
        <el-button type="primary" round :loading="addressModalLoading" @click="saveAddress">保存</el-button>
      </div>
    </Modal> -->
    <el-dialog title="新增通讯录科室" center :append-to-body="true" :visible="deptShow" :close-on-click-modal="false" :destroy-on-close="true" width="550px" @close="cancelDept">
      <el-form
        ref="form2"
        :model="curDept"
        :rules="ruleDept"
        label-position="right"
        label-width="90px"
        style="margin-right: 30px"
      >
        <el-form-item label="科室编码" prop="dept_code">
          <el-input
            v-model.trim="curDept.dept_code"
            :maxlength="20"
            placeholder="请输入科室编码"
          />
        </el-form-item>
        <el-form-item label="科室名称" prop="dept_name">
          <el-input
            v-model.trim="curDept.dept_name"
            :maxlength="50"
            placeholder="请输入科室名称"
          />
        </el-form-item>
        <el-form-item label="院区" prop="branch">
          <el-input
            v-model.trim="curDept.branch"
            :maxlength="50"
            placeholder="请输入院区名称"
          />
        </el-form-item>
        <el-form-item label="简介" prop="desc">
          <el-input
            v-model.trim="curDept.desc"
            :maxlength="50"
            placeholder="请输入科室简介"
          />
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input
            v-model.trim="curDept.phone"
            :maxlength="50"
            placeholder="请输入联系电话"
          />
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input
            v-model.trim="curDept.address"
            :maxlength="50"
            placeholder="请输入科室地址"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelDept">取消</el-button>
        <el-button type="primary" round :loading="deptModalLoading" @click="saveDept">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog center :append-to-body="true" :visible="addressShow" :close-on-click-modal="false" :destroy-on-close="true" width="800px" @close="cancelAddress">
      <div style="display: flex;">
        <div v-loading="avatarLoading" style="width: 140px;height: 140px;padding: 10px;text-align:center;border: 1px solid #eee;">
          <el-upload
            :action="FAST_UPLOAD"
            :headers="{'Authorization': $store.state.Authorization,'tenant': $store.state.tenant.tenant}"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess"
            :on-error="handleAvatarError"
            accept="image/jpeg,image/jpeg,image/png">
              <img style="width: 80px;height: 80px;" :src="curAddress.avatar || defaultImage" />
              <el-button type="text" style="margin: 0 auto">修改头像</el-button>
          </el-upload>
        </div>
        <el-form ref="form1" :model="curAddress" :rules="ruleAddress" style="margin-left: 20px;flex:1;" label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名" prop="name">
                <el-input v-model.trim="curAddress.name" :maxlength="30" placeholder="请输入姓名" size="medium" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用户名" prop="username">
                <el-input v-model.trim="curAddress.username" :disabled="!!curAddress.id" :maxlength="30" placeholder="请输入用户名" size="medium" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工号" prop="employee_id">
                <el-input v-model.trim="curAddress.employee_id" :disabled="!!curAddress.id" :maxlength="30" placeholder="请输入工号" size="medium" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号" prop="phone">
                <el-input v-model.trim="curAddress.phone" :disabled="!!curAddress.id" :maxlength="30" placeholder="请输入手机号" size="medium" />
              </el-form-item>
            </el-col>
            <el-col v-if="!curAddress.id" :span="12">
              <el-form-item label="密码" prop="password">
                <el-input v-model.trim="curAddress.password" :maxlength="30" placeholder="请输入密码" size="medium" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="科室" prop="dept_id">
                <el-select v-model="curAddress.dept_id" filterable placeholder="请选择科室" style="width: 100%">
                  <el-option v-for="a in addressDept" :key="a.id" :value="a.id" :label="a.dept_name">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="角色" prop="role_ids">
                <el-checkbox-group v-model="curAddress.role_ids" style="width: 100%">
                  <el-checkbox v-for="role in roleList" :label="role.id" :key="role.id">{{role.name}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱" prop="email">
                <el-input v-model.trim="curAddress.email" :maxlength="50" placeholder="请输入邮箱" size="medium" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证" prop="id_card">
                <el-input v-model.trim="curAddress.id_card" :maxlength="30" placeholder="请输入身份证" size="medium" />
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="性别" prop="gender">
                <el-radio-group v-model="curAddress.gender" style="width: 80%;text-align: center">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职称" prop="doc_level">
                <el-input v-model.trim="curAddress.doc_level" :maxlength="30" size="medium" placeholder="请输入职称"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职工类型" prop="empl_type">
                <el-input v-model.trim="curAddress.empl_type" :maxlength="30" size="medium" placeholder="请输入职工类型"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="简介" prop="intro" >
                <el-input v-model.trim="curAddress.intro" :maxlength="512" type="textarea" size="medium" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="info" round @click="cancelAddress">取消</el-button>
        <el-button type="primary" round :loading="addressModalLoading" @click="saveAddress">确定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
import { USER_IMPORT, ADDRESS_EXCEL, FAST_UPLOAD, CARINGFAST } from "../../utils/env";
import { getAddressDeptUserApi, getAddressDeptApi, updateAddressDeptApi, addTeamDoctorUserApi, getAddressUserApi, getUserDeptListApi, getAddressRoleApi, addAddressUserApi, updateAddressUserApi } from "../../api/manage";
import "pinyin4js";
import md5 from 'md5'
import pswStrength from '../../utils/pwd';
import defaultImage from "../../images/defaultImage.png"

export default {
  data() {
    const rulePass = (rule, value, callback) => {
      const level = pswStrength.getPasswordLevel(value);
      if (level === 'EASY') {
        callback(new Error('密码强度过低'));
      }
      callback();
    };
    return {
      FAST_UPLOAD,
      defaultImage,
      avatarLoading: false,
      keywords: "",
      active_dept: "",
      search: "",
      searchType: '',
      show_excel: false,
      fileres: null,
      USER_IMPORT,
      members: [],
      depts: [],
      deptList: [],
      deptShow: false,
      curDept: {},
      deptModalLoading: false,
      ruleDept: {
        dept_name: [
          { required: true, message: '请输入科室名称', trigger: 'blur' },
          { required: true, message: '请输入科室名称', trigger: 'change' },
        ],
        dept_code: [
          { required: true, message: '请输入科室编码', trigger: 'blur' },
          { required: true, message: '请输入科室编码', trigger: 'change' },
        ],
      },
      addressShow: false,
      addressModalLoading: false,
      curAddress: {
        name: '',
        username: '',
        employee_id: '',
        phone: '',
        password: '',
        email: '',
        id_card: '',
        gender: '',
        dept_name: '',
        doc_level: '',
        empl_type: '',
        intro: '',
        avatar: '',
        dept_id: '',
        role_ids: []
      },
      ruleAddress: {
        role_ids: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个角色',
            trigger: 'change'
          }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { required: true, message: '请输入姓名', trigger: 'change' },
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '请输入由中英文、数字以及下划线组成的姓名', trigger: 'blur',
          },
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '请输入由中英文、数字以及下划线组成的姓名', trigger: 'change',
          },
        ],
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { required: true, message: '请输入用户名', trigger: 'change' },
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '请输入由中英文、数字以及下划线组成的用户名', trigger: 'blur',
          },
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '请输入由中英文、数字以及下划线组成的用户名', trigger: 'change',
          },
        ],
        password: [
          {
            required: true,
            type: 'string',
            message: '请输入密码',
            trigger: 'blur',
          },
          {
            required: true,
            type: 'string',
            message: '请输入密码',
            trigger: 'change',
          },
          { validator: rulePass, trigger: 'blur' },
          { validator: rulePass, trigger: 'change' },
        ],
        phone: [
          { required: true, message: '请输入手机', trigger: 'blur' },
          { required: true, message: '请输入手机', trigger: 'change' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur',
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'change',
          },
        ],
        email: [
          {
            pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: '邮箱地址格式不正确',
            trigger: 'blur',
          },
          {
            pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: '邮箱地址格式不正确',
            trigger: 'change',
          },
        ],
        id_card: [
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/,
            message: '身份证格式不正确',
            trigger: 'blur',
          },
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/,
            message: '身份证格式不正确',
            trigger: 'change',
          },
        ],
        dept_id: [
          {
            required: true,
            type: 'number',
            message: '请选择科室',
            trigger: 'change',
          },
        ],
        employee_id: [
          {
            required: true,
            message: '请输入工号',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请输入工号',
            trigger: 'change',
          },
          {
            pattern: /^\w+$/,
            message: '请输入由数字、字母以及下划线组成的工号',
            trigger: 'blur',
          },
          {
            pattern: /^\w+$/,
            message: '请输入由数字、字母以及下划线组成的工号',
            trigger: 'change',
          },
        ],
      },
      addressDept: [],
      columns:[
        {
          title: '工号',
          align: 'center',
          key: 'employee_id',
        },
        {
          title: '名称',
          align: 'center',
          key: 'name',
        },
        {
          title: '手机号',
          align: 'center',
          key: 'phone',
        },
        {
          title: '科室',
          align: 'center',
          key: 'dept_name',
        },
        {
          title: '操作',
          align: 'center',
          key: 'action',
          slot: 'action'
        },
      ],
      dataSource: [],
      total: 0,
      page: 1,
      size: 10,
      sizes: [10, 20, 30, 40, 50],
      loading: false,
      deptLoading: false,
      roleList: [],
    };
  },
  computed: {
    windowHeight() {
      return window.innerHeight;
    }
  },
  watch: {
    active_dept() {
      this.page = 1;
      this.getDeptUserList();
    }
  },
  created() {
    this.getMembers();
    this.getRoleList();
  },
  methods: {
    onCurrentChange(current) {
      this.page = current
      this.getDeptUserList()
    },
    onSizeChange(size) {
      this.size = size
      this.getDeptUserList()
    },
    getRoleList() {
      getAddressRoleApi().then(res => {
        if (res.code === 0) {
          this.roleList = res.data;
        } else {
          this.$message.error(res.message);
        }
      })
    },
    getMembers() {
      getAddressDeptUserApi('/1', {
        page: 1,
        size: 9999,
        fetch_child: 1
      }).then(res => {
        if (res.code === 0) {
          this.members = res.data.map(d => {
            d.extra_type = "doctor";
            return d;
          });
          this.getDepts();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getDepts() {
      this.deptLoading = true
      getAddressDeptApi().then(res => {
        if (res.code === 0) {
          this.deptList = this.listToTree(res.data)
          this.depts = res.data.map(d => {
            d.extra_type = "dept";
            return d;
          });
          if (!this.active_dept.name) {
            this.active_dept = this.deptList[0];
          }
          this.$nextTick(() => {
            this.$refs.dept_tree.setCurrentKey(this.active_dept[0]);
          })
        } else {
          this.$message.error(res.message);
        }
      }).finally(() => {
        this.deptLoading = false
      })
    },
    getUserDeptList() {
      getUserDeptListApi().then((res) => {
        if (res.code === 0) {
          this.addressDept = res.data || [];
          if (this.addressDept.length && this.curAddress.dept_id === 0) {
            this.curAddress.dept_id = res.data[0].id;
            this.curAddress.dept_name = res.data[0].dept_name;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getDeptUserList() {
      const { page, size } = this;
      getAddressDeptUserApi(`/${this.active_dept.dept_code}`, {
        page,
        size,
        fetch_child: 1
      }).then(res => {
        if (res.code === 0) {
          this.dataSource = res.data;
          this.total = res['x-total-count'] || res.data.length
        } else {
          this.$Message.error(res.message)
        }
      }).catch(() => (this.loading = false))
    },
    showAddressModal(row) {
      if (row.id) {
        getAddressUserApi(row.username).then(res => {
          if (res.code === 0) {
            const d = res.data;
            d.role_ids = d.roles.map(r => r.id);
            const extra = JSON.parse(d.extra || '{}');
            d.empl_type = extra.empl_type || '';
            d.dept_id = d.dept_id - 0;
            this.curAddress = d;
            this.addressShow = true;
            this.getUserDeptList();
          } else {
            this.$message.error(res.message);
          }
        })
        return;
      }
      this.curAddress = {
        name: '',
        username: '',
        employee_id: '',
        phone: '',
        password: '',
        email: '',
        id_card: '',
        gender: '',
        dept_name: '',
        doc_level: '',
        empl_type: '',
        intro: '',
        avatar: '',
        dept_id: '',
        role_ids: []
      }
      this.$refs.form1 && this.$refs.form1.resetFields();
      this.addressShow = true;
      this.getUserDeptList();
    },
    cancelAddress() {
      this.$refs.form1.resetFields();
      this.addressShow = false;
      this.addressModalLoading = false;
    },
    saveAddress() {
      this.$refs.form1.validate((valid) => {
        if (valid) {
          this.addressModalLoading = true;
          const { avatar,name,username,role_ids, phone,gender,dept_id,id_card, intro, doc_level, empl_type, employee_id, email } = this.curAddress;
          const d = {
            avatar,
            name,
            username,
            employee_id,
            phone,
            dept_id,
            dept_code: this.addressDept.find(
              (d) => d.id == dept_id,
            ).dept_code,
            dept_name: this.addressDept.find(
              (d) => d.id == dept_id,
            ).dept_name,
            role_ids,
            email: email || null,
            id_card,
            gender,
            extra: JSON.stringify({ doc_level, empl_type }),
            intro
          }
          if (!this.curAddress.id) {
            Object.assign(d, {
              device_id: "1",
              device_name: "管理后台",
              device_version: "1.0",
              password: md5(this.curAddress.password)
            })
            addAddressUserApi(d).then(res => {
              if (res.code === 0) {
                this.cancelAddress();
                this.getDeptUserList();
                this.$message.success('保存成功！');
              } else {
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.addressModalLoading = false
            })
            return;
          } else {
            updateAddressUserApi(this.curAddress.username, d).then(res => {
              if (res.code === 0) {
                this.cancelAddress();
                this.getDeptUserList();
                this.$message.success('保存成功！');
              } else {
                this.$message.error(res.message);
              }
            }).finally(() => {
              this.addressModalLoading = false
            })
          }

        }
      });
    },
    showDeptModal() {
      this.deptShow = true;
    },
    cancelDept() {
      this.$refs.form2.resetFields();
      this.curDept = {};
      this.deptShow = false;
      this.deptModalLoading = false;
    },
    saveDept() {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          this.deptModalLoading = true;
          const d = {
            parent_id: 1,
            parent_dept_code: 1,
            dept_name: this.curDept.dept_name,
            dept_code: this.curDept.dept_code,
          };
          updateAddressDeptApi(d).then((res) => {
            this.deptModalLoading = false;
            if (res.code === 0) {
              this.getMembers();
              this.cancelDept();
              this.$message.success('保存成功');
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    querySearch(queryString, cb) {
      const list = [].concat(this.members).concat(this.depts);
      const results = queryString
        ? list.filter(this.createFilter(queryString))
        : list;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(str) {
      const queryString = str.toLowerCase();
      return (item) => {
        if (item.extra_type === "dept") {
          return (
            (item.dept_name &&
              item.dept_name.toLowerCase().indexOf(queryString) >= 0) ||
            (item.dept_name &&
              PinyinHelper.convertToPinyinString(
                item.dept_name,
                "",
                PinyinFormat.WITHOUT_TONE
              ).indexOf(queryString) >= 0) ||
            (item.dept_name &&
              item.dept_code &&
              item.dept_code.indexOf(queryString) >= 0)
          );
        } else if (item.extra_type === "doctor") {
          return (
            (item.name && item.name.toLowerCase().indexOf(queryString) >= 0) ||
            (item.name &&
              PinyinHelper.convertToPinyinString(
                item.name,
                "",
                PinyinFormat.WITHOUT_TONE
              ).indexOf(queryString) >= 0) ||
            (item.username && item.username.indexOf(queryString) >= 0)
          );
        }
      };
    },
    handleDeptNodeClick (data) {
      this.active_dept = data
    },
    listToTree (data) {
      let arr = JSON.parse(JSON.stringify(data))
      const listChildren = (obj, filter) => {
        [arr, obj.children] = arr.reduce(
          (res, val) => {
            if (filter(val)) res[1].push(val)
            else res[0].push(val)
            return res
          },
          [[], []]
        )
        obj.children.forEach(val => {
          if (arr.length)
          // 子元素id 对应父元素parent_id
          { listChildren(val, obj => obj.parent_id === val.id) }
        })
      }
      const tree = {}
      listChildren(
        tree,
        val => arr.findIndex(i => i.id === val.parent_id) === -1
      )
      return tree.children
    },
    renderDeptContent (h, { root, node, data }) {
      return (
        <span class="tree-row" style="display:inline-block;cursor:pointer;width:100%;">
          <span>
            <span>{data.dept_name.length > 10 ? (data.dept_name.substring(0, 10) + '...') : data.dept_name}</span>
            <el-popover
              ref="popover"
              placement="right-start"
              trigger="hover">
              <div>
                <div style="line-height:18px;font-size:13px;padding-top:8px;padding-bottom:8px;">{data.dept_name} (ID: {data.id})</div>
              </div>
              <span slot="reference" style="float:right;margin-right:5px;line-height:24px;color:#ccc;" >
                <i class="el-icon-more" style="transform: rotate(90deg)"></i>
              </span>
            </el-popover>
          </span>
        </span>
      )
    },
    showExcelModal() {
      this.$refs.upload.clearFiles();
      this.show_excel = true;
    },
    hideExcelModal() {
      this.show_excel = false;
    },
    handleUpload() {
      this.$refs.upload.clearFiles();
    },
    handleSuccess(res) {
      if (res.code === 0) {
        this.$message.success("上传成功！");
      } else {
        this.$message.error(res.message);
      }
    },
    handleError(res) {
      this.$refs.upload.clearFiles();
    },
    downloadExcel() {
      location.href = ADDRESS_EXCEL;
    },
    handleSelect(item) {
      if (item.extra_type === "dept") {
        this.active_dept = item;
        this.search = item.dept_name;
        this.searchType = 'dept';
        this.$nextTick(() => {
          this.$refs.dept_tree.setCurrentKey(this.active_dept.id);
        });
      } else if (item.extra_type === "doctor") {
        this.search = item.name;
        this.searchType = 'doctor';
        this.showAddressModal(item);
      }
    },
    beforeAvatarUpload(file) {
      // 封面：上传之前的钩子
      let isImage =
        file.type === 'image/jpg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpeg'
      if (!isImage) {
        this.$Message.error('只能上传后缀名为.jpg、.png和.jpeg的图片文件')
        return false
      }
      let fileSize = file.size
      if (fileSize > 2097152) {
        // 2097152，单位是“字节”，等于2M
        this.$Message.error('您上传的文件大小已超过2M');
        return false
      }
      this.avatarLoading = true;
    },
    handleAvatarSuccess(res, file) {
      // 封面：上传成功的钩子
      if (res.code === 0) {
        this.curAddress.avatar = CARINGFAST + res.data;
      } else {
        this.$message.error(res.message)
      }
      this.avatarLoading = false
    },
    handleAvatarError() {
      this.avatarLoading = false;
      this.$message.error('上传失败，请重新尝试！')
    }
  }
};
</script>
<style lang="less">
.page-addressList{}
</style>
